import { Fragment } from "react";

import Imagem01 from '../../../images/Logo/Logo.png';
import Uvas01 from '../../../images/HomePage/uvas01.jpeg';
import Vinho01 from '../../../images/vinho/vinho01.jpeg';
/* import Ambiente01 from '../../../images/HomePage/night.jpeg'; */
import Chef from '../../../images/HomePage/Chef.jpeg';
import Talher from '../../../images/historia/Talher.jpeg';
import Rolha from '../../../images/historia/Rolha.jpeg';
import Logo20 from '../../../images/Logo/Logo02.jpeg';
import SB01 from '../../../images/Pratos/SB01.jpeg';
import PP01 from '../../../images/Pratos/PP01.jpeg';
import DRK01 from '../../../images/Pratos/DRK01.jpeg';
import CN01 from '../../../images/Cenario/CN01.jpeg';
import CN02 from '../../../images/Cenario/CN02.jpeg';

import './carrocel.css';
import '../../Config/imagens-menu.css';
import './efeito.css';
import './animation.css';


export default function DescHome() {
    return (
        <Fragment>
            <div className="bot">
                <div className="container">
                    <div className="carousel">
                        <img className="slide"
                            draggable="false"
                            src={Rolha}
                            alt="Imagem Teste" />
                        <img className="slide"
                            draggable="false"
                            src={Logo20}
                            alt="Imagem Teste" />
                        <img className="slide"
                            draggable="false"
                            src={SB01}
                            alt="Imagem Teste" />
                        <img className="slide"
                            draggable="false"
                            src={PP01}
                            alt="Imagem Teste" />
                        <img className="slide"
                            draggable="false"
                            src={DRK01}
                            alt="Imagem Teste" />
                        <img className="slide"
                            draggable="false"
                            src={CN01}
                            alt="Imagem Teste" />
                        <img className="slide"
                            draggable="false"
                            src={CN02}
                            alt="Imagem Teste" />
                    </div>
                </div>
            </div>
            <div className="med" id="section-med">

                <div className="description setion-image">
                    <section className="">

                        <img className="imagem-descricao img-logo" src={Imagem01} alt="Logo Adega" />
                    </section>
                </div>
                <div className="descri-text">
                    <div className="container-text">
                        <p className="text-description ">
                            <span className="center-text">Família Adega e Trattoria Santa Helena.</span>
                        </p>
                    </div>

                </div>

            </div>
            <div className="med-second">

                <div className="descri-text">
                    <div className="container-text">
                        <p className="text-description">
                            A Adega e Trattoria Santa Helena é uma instituição familiar,
                            com os três sócios Lucimari, Aquiles e Marcelo, todos em família
                            fizemos os esforços necessários para se obter o sucesso que hoje
                            nossa empresa usufrui. A empresa surgiu da ideia inicial de se
                            fazer apenas uma loja de queijos e vinhos com a sociedade entre a
                            Lucimari e Aquiles Alba. A partir daí, criamos um ambiente aconchegante e
                            com muita atenção, qualidade e dedicação, conseguimos firmar nossa loja,
                            promovendo eventos, degustações e disseminando aprendizado sobre o mundo
                            do vinho. Este momento foi marcado com o quadro da “A Rolha Fundamental”
                            no dia 20 de Julho de 2018, assim como uma pedra fundamental na inauguração
                            de uma obra, essa foi a nossa obra.
                        </p>
                    </div>

                </div>
                <div className="description setion-image">
                    <section className="">

                        <img className="imagem-descricao" src={Uvas01} alt="Uvas" />
                    </section>
                </div>

            </div>

            <div className="med-third">

                <div className="description setion-image">
                    <section className="">

                        <img className="imagem-descricao" src={Vinho01} alt="história" />
                    </section>
                </div>
                <div className="descri-text">
                    <div className="container-text">
                        <p className="text-description">Nossos frutos foram colhidos e bem
                            aceito pela comunidade, porém, vimos a necessidade de se criar
                            algo para acompanhar o vinho, e vimos que esse algo era um
                            restaurante. A partir daí, fizemos a terceira parceria, que
                            foi a vinda do Cheff Marcelo, onde conseguimos definir um
                            ambiente que fosse capaz de acolher o público santa helenense e
                            demais público da região, com a mesma qualidade, o mesmo respeito e
                            a mesma atenção aos clientes, porém com um produto a mais, a nossa
                            Trattoria, evento esse também marcado pelo quadro “O Garfo
                            Fundamental”, inaugurado exatamente dois anos depois, dia 20 de
                            Julho de 2020 em Plena Pandemia  COVID-19.
                        </p>
                    </div>

                </div>

            </div>

            <div className="med-fourth">

                <div className="descri-text">
                    <div className="container-text">
                        <p className="text-description">Aqui um pouco da historia
                            do Chefe de cozinha Marcelo,
                            aprendeu<br /> a gostar cozinha aos 11 anos quando fez primeiro bolo se<br />
                            interessou pela profissão atuando no serviço militar  como cozinheiro <br />
                            e passando por várias experiências daí em diante.buscou formação junto <br />
                            a faculdade univel em 2011 onde dali começou nova paixão no mundo dos <br />
                            vinhos aprendendo com a enóloga  Sandra zottis seu crescimento veio <br />
                            crescendo chegando em santa Catarina. Trabalhou no litoral e em muitos <br />
                            outros restaurantes de renome .hoje sócio proprietário da adega empenha-se <br />
                            a ser melhor no seu ramo na região adorando uma culinária italiana tradicional .
                        </p>
                    </div>

                </div>
                <div className="description setion-image">
                    <section className="">

                        <img className="imagem-descricao" src={Chef} alt="Uvas" />
                    </section>
                </div>

            </div>

            <div className="med-third">{/*fifith*/}

                <div className="description setion-image">
                    <section className="">

                        <img className="imagem-descricao" src={Talher} alt="história" />
                    </section>
                </div>
                <div className="descri-text">
                    <div className="container-text">
                        <p className="text-description">A partir daí, nossos
                            esforços em estar sempre inovando, sempre trazendo novos rótulos,
                            sabores e produtos novos para o público santa helenense, estamos na
                            vanguarda da gastronomia da cidade e acompanhamos o melhor da
                            gastronomia do Oeste do Paraná. Nossa história é galgada de muito
                            trabalho, muita dedicação e com muita amor ao que produzimos,
                            vendemos e em especial muito “Respeito aos nossos Clientes e à
                            Cidade de Santa Helena” que muito nos agrada e nos acolhe.
                        </p>
                    </div>

                </div>

            </div>

            <div className="med-fourth">{/*sixth*/}

                <div className="descri-text">
                    <div className="container-text">
                        <p className="text-description">Aqui um pouco da historia e do
                            surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega<br />
                            Aqui um pouco da historia e do surgimento do simbolo da Adega
                        </p>
                    </div>

                </div>
                <div className="description setion-image">
                    <section className="">

                        <img className="imagem-descricao" src={Rolha} alt="Uvas" />
                    </section>
                </div>

            </div>

        </Fragment>
    )
}